import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import axios from 'axios';



function AchievmentForm(props) {

    const [data, setData] = useState({
        id: '',
        title: '',
        date: '',
        short_desc: ''
    })
    const [file, setFile] = useState();


    function handleInput(e) {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    function handleInputFile(e) {
        setFile(e.target.files[0])
    }

    function handleSubmit() {
        // console.log("oohhoo", props.edit);
        // return;

        
        const postData = new FormData();
        postData.append('title', data.title)
        postData.append('date', data.date)
        postData.append('short_desc', data.short_desc)
        postData.append('school_id', props.modalData.school_id)
        postData.append('image', file)
        postData.append('user_id', props.modalData.id)
        postData.append('user_type', props.type)
        postData.append('user_name', props.modalData.name)
        if (props.edit === 'yes') {
            postData.append('id', data.id)
        }
        else {
            postData.append('id', '')
        }

        axios.post(`${process.env.REACT_APP_MAIN_API}saveAchievement`, postData)
            .then(res => {
                // console.log(res, '/check creer res');
                props.handleClose();
                if (res.status === 200) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Achievement Added Successfully',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    })
                }
            }).catch(err => {
                // console.log(err, 'check creer res');
            })

    }

    // console.log(props, 'modaldata');


    

    useEffect(() => {
        setData(props.modalData)
        // console.log(props.modalData,'props.modalData');
        setFile(props.modalData.image)
    },[props])

    return (
        <>
            <div className='row'>
                <div className='col-md-12 p-2'>
                    <label htmlFor="">Achievement:</label>
                    <input type="text" className='form-control' name="title"
                        value={data?.title}
                        onChange={handleInput} />
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">Image:</label>
                    <input type="file" className='form-control' name="file"
                        onChange={handleInputFile} />
                    {
                        props?.modalData.image ?
                            <img src={`${process.env.REACT_APP_BACKEND}assets/achiement/${file}`} className='img-fluid' style={{ height: 60, margin: 5, }} alt='pews achivement'/>
                            : ''
                    }
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Date:</label>
                    <input type="date" className='form-control' name="date"
                        value={data?.date} onChange={handleInput} />
                </div>
                <div className='col-md-12 p-2'>
                    <label htmlFor="">Short Description:</label>
                    <input
                        type="text"
                        className='form-control' name="short_desc"
                        value={data?.short_desc}
                        onChange={handleInput} />
                </div>
                <div className='text-center pt-4 pb-0'>
                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}> Submit </button>
                </div>
            </div>

        </>
    )
}

export default AchievmentForm;